import { CssBaseline, Toolbar, Box } from '@mui/material';
import React from 'react';
import ConfigSidebar from '../../components/Navbar/ConfigSidebar';
import NewNavbar from '../../components/Navbar/New/Navbar';
import theme from '../../mui-theme';
import FloatingButton from '../../components/elements/Floating-Button';
import { ProjectProvider, useProject } from '../../context/ProjectContext';

const ConfigLayoutContent = ({ children, selectedTab, setSelectedTab }) => {
  const { projectUser } = useProject();

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <CssBaseline />
      <NewNavbar />
      <ConfigSidebar
        theme={theme}
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
        user={projectUser || {}}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          padding: '16px',
        }}>
        <Toolbar />
        <Box sx={{ flexGrow: 1, padding: '16px' }}>{children}</Box>
        <FloatingButton />
      </Box>
    </Box>
  );
};

const ConfigLayout = ({ children, selectedTab, setSelectedTab }) => {
  return (
    <ProjectProvider>
      <ConfigLayoutContent selectedTab={selectedTab} setSelectedTab={setSelectedTab}>
        {children}
      </ConfigLayoutContent>
    </ProjectProvider>
  );
};

export default ConfigLayout;
